<div class="dialog-header">
    <h2 matDialogTitle>{{data.title}}</h2>
    <button mat-icon-button type="button" matTooltip="Close" id="btnClose" class="inverse-button-no-border" (click)="cancel()">
        <mat-icon>close</mat-icon>
    </button>
</div>
<mat-dialog-content align="center">
    <span>{{data.message}}</span>
</mat-dialog-content>
<mat-dialog-actions align="center">
    <button mat-button matTooltip="Cancel Editing" id="btnCancel" class="inverse-button" (click)="cancel()">
        <span>Cancel</span>
    </button>
    <button mat-button matTooltip="Save Editing" id="btnUpdate" class="regular-button" (click)="confirm()">
        <span>Confirm</span>
    </button>
</mat-dialog-actions>
